import { FETCH_HINTS } from '../actions/types';

export default function (state = {}, action) {
  switch (action.type) {
  case FETCH_HINTS:
    return action.payload;
  default:
    return state;
  }
}
